// TODO: change hardcode to api query
import { ICustomerFeedbackEventsData } from './interfaces/CustomerFeedbackGateway';

export enum APPLICATION_KEYS {
  DEV_ENVIRONMENT = 'ab9ecddb-f39c-4798-ae00-bf362eba5363',
  HOTMART_CLUB = 'f57b1bb2-30e3-4fd0-9c59-cfe00909f280',
  TEACHABLE = 'aa2d356b-e2f0-45e8-9725-e0efc7b5d29c',
}

type AvailableCsatEvent = {
  [key in APPLICATION_KEYS]: ICustomerFeedbackEventsData;
};

const SURVEY_ID_CLUB = '0b4631c365b09a33';
const SURVEY_ID_DEVELOPMENT = 'c08ecf06eb521cb3';

export const CSAT_EVENTS_BY_APPLICATION_ID: Partial<AvailableCsatEvent> = {
  'f57b1bb2-30e3-4fd0-9c59-cfe00909f280': {
    ON_CLICK_CUSTOMER_FEEDBACK_SETTINGS_ITEM: {
      id: SURVEY_ID_CLUB,
      active: true,
    },
  },
  'ab9ecddb-f39c-4798-ae00-bf362eba5363': {
    ON_CLICK_CUSTOMER_FEEDBACK_SETTINGS_ITEM: {
      id: SURVEY_ID_DEVELOPMENT,
      active: true,
    },
  },
};
